import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeNew from "./components/Page/HomeNew/Home";
import GameMobile from "./components/Page/Game/GameMobile";
import QuestionManager from "./components/Page/QuestionManager/QuestionManager";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeNew />} />
        <Route path="/game" element={<GameMobile />} />
        <Route path="/questions" element={<QuestionManager />} />
      </Routes>
    </Router>
  );
}

export default App;
